import { Icon } from "@iconify/react";

export function Loading() {
  return (
    <div className="absolute top-0 left-0 right-0 bottom-0 bg-white flex items-center justify-center">
      <Icon icon="eos-icons:three-dots-loading" style={{ fontSize: 50 }} />
    </div>
  );
}
